/* Luminous universal sticky buy pill — reveal on scroll.
   Shows the floating buy pill once the visitor scrolls past a threshold, and
   (optionally) hides it while the on-page Buy section (#buy) is in view so it
   never overlaps the main CTA. No-ops gracefully if the pill is absent. */
(function () {
  'use strict';

  function init() {
    var pill = document.querySelector('[data-sticky-buy]');
    if (!pill) return;

    var cfg = {};
    var configEl = document.querySelector('[data-sticky-buy-config]');
    if (configEl) {
      try {
        cfg = JSON.parse(configEl.textContent) || {};
      } catch (e) {
        cfg = {};
      }
    }

    var showAfterPx = typeof cfg.showAfterPx === 'number' ? cfg.showAfterPx : 480;
    var hideNearBuy = cfg.hideNearBuy !== false;
    var hideSelector = cfg.hideSelector || '#buy';

    var buyInView = false;

    function setVisible(visible) {
      pill.classList.toggle('is-visible', visible);
      pill.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      setVisible(y > showAfterPx && !buyInView);
    }

    // Hide the pill while the on-page Buy section is visible (homepage only —
    // the target simply won't exist on other templates, and that's fine).
    if (hideNearBuy && 'IntersectionObserver' in window) {
      var target = document.querySelector(hideSelector);
      if (target) {
        var io = new IntersectionObserver(
          function (entries) {
            buyInView = entries[0].isIntersecting;
            update();
          },
          { rootMargin: '0px 0px -20% 0px' }
        );
        io.observe(target);
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    setVisible(false);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
